import { isDuApp } from '@/utils/appUtils/getDevice'
import Jockeys from '@/utils/jockey'
import React from 'react'
import styles from '../index.module.less'
import { CardGoods, GoodsItem } from './good-item'
import { cdnSrc } from '@/utils/cdn'
import { viewMore } from '../i18.config'
export class CardConstructor extends React.Component<IProps> {
  constructor(props) {
    super(props)
  }

  steTitleStyle(v) {
    return {
      background: `linear-gradient(-225deg, ${v.startTitleBackColor}, ${v.endTitleBackColor})`,
      color: v.titleColor,
    }
  }

  goToVenue(url: string, linkType: number) {
    // 埋点
    if (isDuApp()) {
      if (linkType == 1) {
        // 1 原生主题页
        Jockeys.openNativePage(url)
      } else {
        // 2 h5主题页
        Jockeys.openNativePage('/web/browser', { url })
      }
    } else {
      window.location.href = url
    }
  }

  render() {
    const { card, showBanner, lang } = this.props
    const { venueTitle, venueDesc, products, headImage, landingPageUrl, linkType } = card
    const { goToVenue, steTitleStyle } = this

    const goods = products.map((product) => {
      return <GoodsItem key={product.id} product={product} />
    })

    const cdnSrcString = !headImage ? '' : cdnSrc(headImage, [{ mode: 'resize', width: 343 * 3 }])

    return (
      <div className={styles['card']}>
        {/* todo: 图片处理需要弄 */}
        {showBanner ? (
          <img
            className={styles['head-image']}
            src={cdnSrcString}
            alt=""
            onClick={() => goToVenue(landingPageUrl, linkType)}
          />
        ) : (
          <div
            className={`${styles['top-area']}
            ${styles['up-relation']}`}
            style={showBanner ? {} : steTitleStyle(card)}
            onClick={() => goToVenue(landingPageUrl, linkType)}
          >
            <div className={styles['top-area-left']}>
              <div className={styles['title']}>{venueTitle}</div>
              <div className={styles['desc']}>{venueDesc}</div>
            </div>
            <div className={styles['top-area-right']}>
              {showBanner ? '' : <div className={styles['detail-button']}>{viewMore[lang]}</div>}
            </div>
          </div>
        )}
        {/* goods-area */}
        <div className={`${styles['goods-area']} ${styles['up-relation']}`}> {goods} </div>
      </div>
    )
  }
}

export interface Cards {
  endTitleBackColor: string
  headImage?: string
  landingPageUrl: string
  linkType: number
  products: CardGoods[]
  startTitleBackColor: string
  titleColor: string
  venueDesc: string
  venueTitle: string
}

interface IProps {
  card: Cards
  showBanner: boolean
  lang: string
}
